import { render, staticRenderFns } from "./ListPotensiDesa.vue?vue&type=template&id=686ffdce&scoped=true"
import script from "./ListPotensiDesa.vue?vue&type=script&lang=js"
export * from "./ListPotensiDesa.vue?vue&type=script&lang=js"
import style0 from "./ListPotensiDesa.vue?vue&type=style&index=0&id=686ffdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ffdce",
  null
  
)

export default component.exports